import {
  Navigate,
  // Outlet, 
  useRoutes
} from 'react-router-dom';
// auth
import { AuthGuard, GuestGuard } from '../auth/guard/index';
// layouts
import CompactLayout from '../layouts/compact';
import DashboardLayout from '../layouts/dashboard';
//
import {
  Page403,
  Page404,
  Page500,
  PageOne,
  PageTwo,
  LoginPage,
  SignUpPage,
  PageThree,
  Scan,
  Settings,
  Product,
  ProductDetail,
  Book,
  BookDetail,
  BookCreatePage,
  BookEditPage,
  AccountSettings,
  UserList,
  UserDetail,
  NewUser,
  ForgotPasswordPage,
  // AddNewPassword,
  UserEditPage,
  HomePage,
  Dashboard,
  Notification,
  SmsCodeVerification,
  LoginWithOtp,
  OrganizationList,
  NewOrganization,
  OrganizationDetailPage,
  OrganizationEditPage,
  EmailVerification,
  InvoiceListPage,
  InvoiceDetailPage,
  InvoiceEditPage,
  InvoiceNewPage,
  ApiKeys,
  ModelListing,
  ModelCreatePage,
  ModelDetailsPage,
  ModelEditPage,
  PlanAdminListing,
  // PlanClientListing,
  OrgSubsListing,
  MySubsListing,
  FileUploads,
  FolderUploads,
  PublicPayment,
  AuditLogs,
  EncryptionKeys,
  Payment,
  PlanCreatePage,
  TransactionListPage,
  TransactionDetailPage,
  OrgAdminTransactionListPage,
  ModelTransactionListPage,
  TransactionSyncListPage,
  CompressionListPage,
  PlanEditPage,
  Threshold,
  // LandingPage,
  CustomEmail,
  DataTraining,
  // CustomEmail,
  // PublicProduct,
  // PublicProductDetail,
  // PublicCheckoutPage,
  // PublicLogin,
  // PublicSignUp,
  Upload,
  DocumentManagerPage,
  DocumentManagerSharedPage,
  DocumentManagerBinPage,
  CustomTemplates,
  CreateTemplateCategory,
  LogoutPage,
  OrgSubsPage, //v1
  SuperAdminFileUploads
} from './elements';

import RoleBasedGuard from '../auth/guard/role-based-guard';
import { AllowedRoles, ClientAdminRoles } from '../utils/constants/constants';
// import { PATH_AFTER_LOGIN } from 'src/config-global';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';
// import { useAuthContext } from '../auth/hooks';
// import { routePrefix } from 'src/utils/methods/StandardMethods';
// import MainLayout from 'src/layouts/main/layout';
// import { ADMIN_PATH_AFTER_LOGIN } from '../config-global';
// import { Suspense } from 'react';
// import { SplashScreen } from 'src/components/loading-screen';
import TaskCreatePage from 'src/pages/dataTraining/new/TaskCreatePage';
import { SignUpPageV1 } from './elements-v1';
// import AuthModernLayout from 'src/layouts/auth/modern';
loadStripe.setLoadParameters({ advancedFraudSignals: false });

// ----------------------------------------------------------------------

export default function Router() {

  // const { user } = useAuthContext();
  const stripePromise = loadStripe(
    'pk_test_51MCdk4SCWitQhvQv8oZEJi9HloUhXijxSNaxHhFtTdqL4Ookm5QGtggeF0Zqv9dbztyIew2GXv6hu5qzXuZTlWd7004MtMph30'
  )
  return useRoutes([

    {
      path: '/',
      children: [
        { element: <Navigate to={'/v1/'} replace />, index: true }, // used for lightweight app 
        // { element: <Navigate to={'login'} replace />, index: true }, // uncomment this to get to original code 
        {
          path: 'login',
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },
        {
          path: 'logout',
          element: (
            <GuestGuard>
              <LogoutPage />
            </GuestGuard>
          ),
        },
        {
          path: 'forgot-password',
          element: <GuestGuard>
            <ForgotPasswordPage />
          </GuestGuard>
        },
        {
          path: 'login-with-otp',
          element: <GuestGuard>
            <LoginWithOtp />
          </GuestGuard>
        },
        {
          path: 'verify-code/:phonenumber',
          element:
            <GuestGuard>
              <SmsCodeVerification />
            </GuestGuard>
        },

        {
          path: 'register',
          element: (
            <GuestGuard>
              <SignUpPage />
            </GuestGuard>
          ),
        },
      ],
    },
    {
      path: ':orgCode?/app',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        // { element: <Navigate to={PATH_AFTER_LOGIN(routePrefix(user))} replace />, index: true },
        // { path: 'dashboard', element: <Product /> },
        { path: 'one', element: <PageOne /> },
        { path: 'two', element: <PageTwo /> },
        { path: 'three', element: <PageThree /> },
        { path: 'home', element: <HomePage /> },
        { path: 'dashboard', element: <Dashboard /> },
        { path: 'upload', element: <Upload /> },
        {
          path: 'product', children: [
            { element: <Navigate to={'list'} replace />, index: true },
            { path: 'list', element: <Product /> },
            { path: ':id/detail', element: <ProductDetail /> },
          ]
        },
        {
          path: 'book', children: [
            { element: <Navigate to={'list'} replace />, index: true },
            { path: 'list', element: <Book /> },
            { path: ':id/detail', element: <BookDetail /> },
            { path: ':id/edit', element: <BookEditPage /> },
            { path: 'new', element: <BookCreatePage /> },
          ]
        },
        {
          path: 'user',
          children: [
            { element: <Navigate to={'list'} replace />, index: true },
            { path: 'list', element: <UserList /> },
            { path: ':id/detail', element: <UserDetail /> },
            { path: 'detail/:id', element: <UserDetail /> },
            { path: 'edit/:id', element: <UserEditPage /> },
            { path: ':id/edit', element: <UserEditPage /> },
            { path: 'new', element: <NewUser /> },
          ]
        },
        {
          path: 'invoice', children: [
            { element: <Navigate to={'list'} replace />, index: true },
            { path: 'list', element: <InvoiceListPage /> },
            { path: ':id/detail', element: <InvoiceDetailPage /> },
            { path: ':id/edit', element: <InvoiceEditPage /> },
            { path: 'new', element: <InvoiceNewPage /> },
          ]
        },
        {
          path: 'transaction', children: [
            { element: <Navigate to={'list'} replace />, index: true },
            { path: 'list', element: <TransactionListPage /> },
            { path: ':id/detail', element: <TransactionDetailPage /> },
          ]
        },
          {
          path: 'orgTransaction', children: [
            { element: <Navigate to={'list'} replace />, index: true },
            { path: 'list', element: <OrgAdminTransactionListPage /> },
          ]
        },
        {
          path: 'modelTransaction', children: [
            { element: <Navigate to={'list'} replace />, index: true },
            { path: 'list', element: <ModelTransactionListPage /> },
          ]
        },

        {
          path: 'transactionSync', children: [
            { element: <Navigate to={'list'} replace />, index: true },
            { path: 'list', element: <TransactionSyncListPage /> },
          ]
        },
        {
          path: 'compression',
          children: [
            { element: <Navigate to={'list'} replace />, index: true },
            { path: 'list', element: <CompressionListPage /> },
          ],
        },

        {
          path: 'organization',
          children: [
            { element: <Navigate to={'list'} replace />, index: true },
            { path: 'list', element: <OrganizationList /> },
            { path: ':id/detail', element: <OrganizationDetailPage /> },
            { path: ':id/edit', element: <OrganizationEditPage /> },
            { path: 'new', element: <NewOrganization /> },
          ]
        },
        {
          path: 'models',
          children: [
            { element: <Navigate to={'list'} replace />, index: true },
            { path: 'list', element: <RoleBasedGuard roles={AllowedRoles} hasContent><ModelListing /></RoleBasedGuard> },
            { path: ':id/detail', element: <RoleBasedGuard roles={AllowedRoles} hasContent><ModelDetailsPage /></RoleBasedGuard> },
            { path: ':id/edit', element: <RoleBasedGuard roles={AllowedRoles} hasContent><ModelEditPage /></RoleBasedGuard> },
            { path: 'new', element: <RoleBasedGuard roles={AllowedRoles} hasContent><ModelCreatePage /></RoleBasedGuard> },
          ]
        },
        { path: 'payment/:invoiceId', element: <Elements stripe={stripePromise}><Payment /></Elements> },

        {
          path: 'plans',
          children: [
            { element: <Navigate to={'list'} replace />, index: true },
            {
              path: 'list',
              element: <>
                <RoleBasedGuard roles={AllowedRoles} ><PlanAdminListing /></RoleBasedGuard>
                <RoleBasedGuard roles={ClientAdminRoles} ><OrgSubsPage /></RoleBasedGuard>{/* //v2 */}

                {/*  <RoleBasedGuard roles={ClientAdminRoles} ><PlanClientListing /></RoleBasedGuard> */}
              </>
            },
            {
              path: 'v1/list',
              element: <>
                {/* <RoleBasedGuard roles={AllowedRoles} ><PlanAdminListing /></RoleBasedGuard> */}
                <RoleBasedGuard roles={ClientAdminRoles} ><OrgSubsPage /></RoleBasedGuard>
              </>
            },
            { path: ':id/detail', element: <RoleBasedGuard roles={AllowedRoles} hasContent><ModelDetailsPage /></RoleBasedGuard> },
            { path: ':id/edit', element: <RoleBasedGuard roles={[...AllowedRoles, ...ClientAdminRoles]} hasContent><PlanEditPage /></RoleBasedGuard> },
            { path: 'new', element: <RoleBasedGuard roles={[...AllowedRoles, ...ClientAdminRoles]} hasContent><PlanCreatePage /></RoleBasedGuard> },
          ]
        },
        {
          path: 'subscriptions',
          children: [
            { element: <Navigate to={'self'} replace />, index: true },
            {
              path: 'self',
              element: <MySubsListing />
            },
            {
              path: 'org',
              element: <RoleBasedGuard roles={ClientAdminRoles} ><OrgSubsListing /></RoleBasedGuard>
            },
            // { path: ':id/edit', element: <RoleBasedGuard roles={AllowedRoles} hasContent><ModelEditPage /></RoleBasedGuard> },
            // { path: 'new', element: <RoleBasedGuard roles={AllowedRoles} hasContent><ModelCreatePage /></RoleBasedGuard> },
          ]
        },
        {
          path: 'notification',
          children: [
            { element: <Navigate to={'list'} replace />, index: true },
            { path: 'list', element: <Notification /> },
          ]
        },
        { path: 'file-uploads', element: <FileUploads /> },
        { path: 'file-upload', element: <SuperAdminFileUploads /> },

        { path: 'folder-uploads', element: <FolderUploads /> },
        {
          path: 'custom-templates', element: <CustomTemplates />
        },
        {
          path: 'create-template-categories', element: <CreateTemplateCategory />
        },
        { path: 'threshold', element: <Threshold /> },
        { path: 'settings/user', element: <AccountSettings /> },
        { path: 'api-keys', element: <ApiKeys /> },
        {
          path: 'audit-trial', element: <AuditLogs />
        },
        { path: 'encryption-keys', element: <EncryptionKeys /> },
        {
          path: 'file-manager', children: [
            {
              path: 'personal',
              element: <DocumentManagerPage />
            },
            {
              path: 'shared',
              element: <DocumentManagerSharedPage />
            },
            {
              path: 'bin',
              element: <DocumentManagerBinPage />
            }
          ]
        },
        // {
        //   path: 'user',
        //   children: [
        //     { element: <Navigate to="//user/four" replace />, index: true },
        //     { path: 'four', element: <PageFour /> },
        //     { path: 'five', element: <PageFive /> },
        //     { path: 'six', element: <PageSix /> },
        //   ],
        // },
        {
          path: 'theme-settings', element: <Settings />
        }, {
          path: 'custom-email', element: <CustomEmail />
        },
        { path: 'data-training', element: <DataTraining /> },
        {
          path: 'data-training',
          children: [
            { element: <Navigate to={'list'} replace />, index: true },
            { path: 'list', element: <DataTraining /> },
            { path: 'new', element: <TaskCreatePage /> },
          ]
        },
      ],
    },
    {
      path: '/scan', element: <Scan />
    },


    {
      path: '/v1/',
      children: [
        { element: <Navigate to={'login'} replace />, index: true },
        {
          path: 'login',
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },
        {
          path: 'signup',
          element: (
            <GuestGuard>
              <SignUpPageV1 />
            </GuestGuard>
          ),
        },
      ],
    },

    {
      path: '/',
      children: [
        { path: '403', element: <CompactLayout><Page403 /></CompactLayout> },
        { path: 'email-verify/:token', element: <CompactLayout><EmailVerification /></CompactLayout> },
        { path: '404', element: <CompactLayout><Page404 /></CompactLayout> },
        { path: '500', element: <CompactLayout><Page500 /></CompactLayout> },
      ],
    },
    {
      path: '/payments/:token', element: <PublicPayment />,
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ])
}
